'use client'

import ChatArea from '@/views/chat/chat-area'
import ChatProvider from '@/context/ChatProvider'
import SocketProvider from '@/context/SocketProvider'
import ZustandProvider from '@/context/ZustandProvider'

function Page() {
  return (
    <ZustandProvider>
      <ChatProvider>
        <SocketProvider>
          <ChatArea />
        </SocketProvider>
      </ChatProvider>
    </ZustandProvider>
  )
}

export default Page
